type SingleClickFunc = (callback: undefined | (() => void), doubleCallback?: () => void) => void;

export default function makeSingleClick(): SingleClickFunc {
    let times: number = 0;

    const singleClick = (callback: undefined | (() => void), doubleCallback?: () => void) => {
        times += 1;
        setTimeout(() => {
            if (times === 1 && typeof callback === 'function') {
                callback();
            } else if (times === 2 && typeof doubleCallback === 'function') {
                doubleCallback();
            }
            times = 0;
        }, 300);
    };

    return singleClick;
}
